import { render, staticRenderFns } from "./ContractDataTab.vue?vue&type=template&id=55d2b82c&scoped=true"
import script from "./ContractDataTab.vue?vue&type=script&lang=js"
export * from "./ContractDataTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d2b82c",
  null
  
)

export default component.exports